import {
  userLoginForm,
  userRegisterForm,
  loginForm,
  loginProps,
  loginRules,
} from "./UserLoginForm";
import { userPasswordRecoveryForm } from "./UserPasswordRecovery";
import { password } from "./RegisterUserForm";
import {
  registerCardForm,
  registerCardProps,
  registerCardRules,
} from "./RegisterCardForm";
export default class User {
  static getLoginForm() {
    return userLoginForm;
  }
  static getPasswordRecoveryForm() {
    return userPasswordRecoveryForm;
  }
  static getRegisterLoginForm() {
    return userRegisterForm;
  }
  static getPasswordForm() {
    return password;
  }
  static getRegisterCardForm() {
    return registerCardForm;
  }
  static getRegisterCardProps() {
    return registerCardProps;
  }
  static getRegisterCardRules() {
    return registerCardRules;
  }
  static getloginForm() {
    return loginForm;
  }
  static getloginProps() {
    return loginProps;
  }
  static getloginRules() {
    return loginRules;
  }
}
